import { ImageGallery } from 'elements/minute/sidebar/sidebarComponents/complex/ImageGallery';
import { useContext } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import { CtxModal } from 'session/ctxModal';
import styled from 'styled-components/macro';

export interface IGalleryModal {
    selectedImageUrl: string;
    additionalImages?: string[];
    onSelected?: (imageUrl: string) => void;
}

interface Props {
    data: IGalleryModal;
    className?: string;
}

export const GalleryModal = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const ctxModal = useContext(CtxModal);

    function onSelected(imageUrl: string) {
        console.log('On selected', imageUrl);
        props.data.onSelected?.(imageUrl);
        ctxModal.setModal(null);
    }

    return (
        <S_GalleryModal className={props.className}>
            <ImageGallery
                additionalImages={ctxEdit.map.imageGallery}
                dragAndDropEnabled={false}
                selectedImageUrl={props.data.selectedImageUrl}
                initialRowsVisible={5}
                extraRowsVisibleOnMore={8}
                onSelected={onSelected}
                hideOpenModal={true}
                columns={7}
                imageSize={90}
                maxHeight={500}
            />
        </S_GalleryModal>
    );
};

const S_GalleryModal = styled.div`
    display: flex;
    padding: 30px;
`;
